import { jsxs, jsx } from "react/jsx-runtime";
const ConversationSkeleton = () => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: "768px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "flex-end",
              animation: "fadeIn 0.3s ease-in"
            },
            children: /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  width: "min(70%, 280px)",
                  height: "48px",
                  backgroundColor: "#EEF4FC",
                  borderRadius: "18px",
                  borderBottomRightRadius: "5px",
                  animation: "pulse 1.5s ease-in-out infinite"
                }
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "flex-start",
              animation: "fadeIn 0.3s ease-in 0.2s both"
            },
            children: /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px"
                },
                children: [
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        width: "100%",
                        height: "80px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "12px",
                        animation: "pulse 1.5s ease-in-out infinite"
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        width: "85%",
                        height: "60px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "12px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        animationDelay: "0.2s"
                      }
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ jsx("style", { children: `
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        ` })
      ]
    }
  );
};
export {
  ConversationSkeleton
};
//# sourceMappingURL=ConversationSkeleton.js.map
